"use client"
import * as React from "react"
import { ThemeProvider as NextThemesProvider } from "next-themes"

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  // Dark mode is built but hidden pending a dedicated polish pass
  // (see docs/PREMIUM_UPLIFT.md). forcedTheme pins every user to light and
  // overrides any previously-persisted "dark" preference. To re-enable dark
  // mode later: remove forcedTheme and restore <ThemeToggle /> in Topbar.
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="light"
      forcedTheme="light"
      enableSystem={false}
      storageKey="odonboard-theme"
    >
      {children}
    </NextThemesProvider>
  )
}